export default {"src":"/_next/static/media/collection_course.01b08d82.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};